import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {PostPayloadInterface} from "../models/post-payload.interface";
import {ApiUri, BaseApiUri, BaseRepository, HellpositoryConfig} from "hellpository";


@BaseApiUri('dashboard/staff/restaurants')
@Injectable({
  providedIn: 'root'
})
export class RestaurantRepository extends BaseRepository<PostPayloadInterface> {

  constructor(public httpClient: HttpClient, public hellpConfig: HellpositoryConfig) {
    super(httpClient, hellpConfig);
  }

  @ApiUri('/for-user/?dtoClass=FuckingSlimRestaurantDTO')
  getAllForUser() {
    return super.get();
  }
}
